import { useEffect, useState } from 'react';
import { useRouteError } from 'react-router-dom';
import { isStaleBundle } from '../utils/appBundle';

const runningBundle = () => document.querySelector<HTMLScriptElement>('script[type="module"][src]')?.getAttribute('src') ?? null;

/** What a page that throws while rendering shows, in place of React Router's developer screen. A tab left open across
 *  a deploy runs the old bundle against the new API, so when the server now serves a different bundle the page
 *  reloads onto it; otherwise it says what failed and offers a reload. */
export default function RouteErrorPage() {
  const error = useRouteError();
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    fetch(window.location.pathname, { cache: 'no-store', headers: { Accept: 'text/html' } })
      .then(response => response.text())
      .then(html => { if (isStaleBundle(runningBundle(), html)) window.location.reload(); else setChecked(true); },
        () => setChecked(true));
  }, []);
  if (!checked) return null;
  return (
    <main className="not-found">
      <div className="not-found-body">
        <p className="not-found-code">{error instanceof Error ? error.message : String(error)}</p>
        <h1 className="not-found-title">Something went wrong</h1>
        <button type="button" className="not-found-home" onClick={() => window.location.reload()}>Reload</button>
      </div>
    </main>
  );
}
